import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AuthRoutes from "Routes/Components/Auth";

import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const Breadcrumb = ({ currentRoute, externalComponent, parent }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const [parents, setParents] = useState([]);

  useEffect(() => {
    if (parent) {
      const routes = AuthRoutes;
      let current_parent_route = routes[parent];
      let new_parents = [];

      while (current_parent_route) {
        if (!current_parent_route.name) break;

        new_parents = [current_parent_route, ...new_parents];

        current_parent_route = routes[current_parent_route.parent];
      }

      setParents(new_parents);
    } else {
      setParents([]);
    }
  }, [parent]);

  return (
    <S.Wrapper>
      <S.Routes>
        <GetIcon
          name="ChevronLeft"
          color={theme.colors.neutral.white}
          onClick={() => navigate(-1)}
        />
        <S.Highlight>{parents.length ? "/" : ""} Voltar</S.Highlight>
      </S.Routes>

      <S.PageName>{currentRoute?.toUpperCase()}</S.PageName>

      {externalComponent && (
        <S.ExternalWrapper>{externalComponent}</S.ExternalWrapper>
      )}
    </S.Wrapper>
  );
};

export default Breadcrumb;
